import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../contexts/AuthContext";
import GlobalErrorBoundary from "../components/common/GlobalErrorBoundary";
import { OfflineProvider } from "../features/offline";
import { useAnalyticsBootstrap } from "../features/analytics";
import { DesignSystemProvider } from "../design/providers/DesignSystemProvider";
import { ActiveSportProvider } from "../sports/ActiveSportContext";
import NavigationMemorySync from "./NavigationMemorySync";
import ArenaInvitationNotificationSync from "./ArenaInvitationNotificationSync";
import FriendRequestNotificationSync from "./FriendRequestNotificationSync";

function AnalyticsBootstrap({ children }) {
  useAnalyticsBootstrap();
  return children;
}

/** CRA sets PUBLIC_URL to "." when package.json homepage is "." — invalid React Router basename. */
function appRouterBasename() {
  const base = (process.env.PUBLIC_URL || "").trim();
  if (!base || base === ".") return "";
  return base.replace(/\/$/, "");
}

export default function AppProviders({ children }) {
  return (
    <GlobalErrorBoundary>
      <DesignSystemProvider>
        <BrowserRouter basename={appRouterBasename()} future={{ v7_startTransition: true }}>
          <NavigationMemorySync />
          <AuthProvider>
            <ArenaInvitationNotificationSync />
            <FriendRequestNotificationSync />
            <ActiveSportProvider>
              <OfflineProvider>
                <AnalyticsBootstrap>{children}</AnalyticsBootstrap>
              </OfflineProvider>
            </ActiveSportProvider>
          </AuthProvider>
        </BrowserRouter>
      </DesignSystemProvider>
    </GlobalErrorBoundary>
  );
}
